import { DEFAULT_THEME } from 'lib/metadata';

export default {
    ...DEFAULT_THEME.colors,
};
